// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"130":"9170be68","389":"c2cb84d6","515":"5e7495b5","526":"8e1a7d05","541":"6fd5a3d3","652":"8e1a7d05","712":"aecdc089"}[chunkId] + ".chunk.css";
};